import React, { useId } from 'react';

/**
 * Racing-style start flag — pole + checkered rectangle.
 * Same proportions as MilestoneFlagIcon so origin markers sit with milestones.
 */
export function CheckeredFlagIcon({
  size = 16,
  className = '',
  color,
}) {
  const clipId = `cf-${useId().replace(/:/g, '')}`;
  const dark = color || '#3f3f46';
  const light = '#e4e4e7';
  const pole = color || '#71717a';

  return (
    <svg
      className={`checkered-flag-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <clipPath id={clipId}>
          <rect x="7.4" y="3" width="12.6" height="9" rx="1" />
        </clipPath>
      </defs>
      <rect x="5" y="3" width="2.4" height="18" rx="1.2" fill={pole} />
      <rect x="7.4" y="3" width="12.6" height="9" rx="1" fill={light} />
      <g clipPath={`url(#${clipId})`}>
        <rect x="7.4" y="3" width="4.2" height="4.5" fill={dark} />
        <rect x="15.8" y="3" width="4.2" height="4.5" fill={dark} />
        <rect x="11.6" y="7.5" width="4.2" height="4.5" fill={dark} />
      </g>
    </svg>
  );
}

export default CheckeredFlagIcon;
